import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { usePixelatedConfig } from "../config/config.client";
import { SmartErrorBoundary } from "../foundation/smarterrorboundary";
// https://developers.google.com/maps/documentation/embed/embedding-map
const googleMapsPropTypes = {
    /** Accessible iframe title */
    title: PropTypes.string,
    /** iframe width (pixels or %) */
    width: PropTypes.string,
    /** iframe height (pixels) */
    height: PropTypes.string,
    /** iframe frameBorder attribute */
    frameBorder: PropTypes.string,
    /** Inline style object for the iframe */
    style: PropTypes.object,
    /** Maps embed mode (required) */
    map_mode: PropTypes.string.isRequired,
    /** Additional query parameters for the embed URL */
    parameters: PropTypes.string,
};
/**
 * GoogleMaps — Embed a Google Maps iframe using the Maps Embed API.
 *
 * @param {GoogleMapsType} props - Component properties.
 */
export function GoogleMaps(props) {
    const config = usePixelatedConfig();
    const apiKey = config?.integrations?.google?.api_key || config?.integrations?.googleMaps?.apiKey;
    if (!apiKey) {
        return (_jsx("div", { className: "smart-error-boundary-fallback", children: _jsx("p", { children: "Sorry, something went wrong loading GoogleMaps." }) }));
    }
    return (_jsx(SmartErrorBoundary, { boundaryName: "GoogleMaps", children: _jsx("div", { className: "gmap", suppressHydrationWarning: true, children: _jsx("iframe", { title: props.title || "Google Map", width: props.width || "600", height: props.height || "400", frameBorder: props.frameBorder || "0", style: props.style || { border: 0 }, referrerPolicy: "no-referrer-when-downgrade", src: `https://www.google.com/maps/embed/v1/${props.map_mode}?key=${apiKey}&${props.parameters}`, allowFullScreen: true }) }) }));
}
GoogleMaps.propTypes = googleMapsPropTypes;
